import React from 'react';
import Icon from '../common/Icon';
import { play } from '../../hooks/useSound';

// Map a toast variant to its sound (info toasts stay silent — the triggering
// tap already gave feedback).
const VARIANT_SOUND = {
  success: 'toast-success',
  error: 'toast-error',
};

const Toast = ({ showToast, setShowToast, message, icon = 'exclamation', variant = 'info' }) => {
  React.useEffect(() => {
    if (showToast && VARIANT_SOUND[variant]) play(VARIANT_SOUND[variant]);
  }, [showToast, variant]);

  return (
    <div className="toast-container p-3">
      <div className={`toast ${showToast ? 'show' : 'hide'}`} role="alert" aria-live="assertive" aria-atomic="true">
        <div className="toast-header">
          {icon && <Icon name={icon} theme="primary" className="me-2" />}
          <strong className="me-auto">{message}</strong>
          <button type="button" className="btn-close" onClick={() => setShowToast(false)}></button>
        </div>
      </div>
    </div>
  );
};

export default Toast;
